import router from "@/router";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const getInitialState = () => ({
  account: {
    firstname: "",
    lastname: "",
    role: "",
    auth: false,
  },
});

const state = getInitialState();

export default new Vuex.Store({
  state,
  mutations: {
    setAccount(state, { account }) {
      state.account = account;
      state.account.auth = true;
    },
    resetStore(state) {
      Object.assign(state, getInitialState());
      localStorage.clear();
      router.push({ name: "login" }).then();
    },
  },
  actions: {},
  plugins: [createPersistedState({ storage: localStorage })],
});
